import _curry from "ramda/es/curry";
export default _curry(function (d, f) {
  return Math.round(f * Math.pow(10, d)) / Math.pow(10, d);
});